import type { IParagraphNode } from "~/models/IParagraphNode";

export function useParagraphDescription(
  nodes: IParagraphNode[],
  limit: number = 200
) {
  const recurseText = (node?: IParagraphNode) => {
    if (!node) {
      return "";
    }
    if (node.properties.tag === "#text") {
      return node.properties.text;
    }
    return node.children.flatMap(recurseText).join("");
  };

  let string = "";

  string = recurseText(nodes[0]);

  if (string.length < limit) {
    string = nodes.flatMap(recurseText).join("");
  }

  string = useTruncateText(string, limit);
  return string;
}
